// 导入 axios
import axios from "axios";
import router from "@/router";
import { Message } from "element-ui";
import routerIndex from "../router/index";

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_BASE_API,
});

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const token = localStorage.getItem("Authorization");
    if (!token) {
      router.push({ name: "Login" });
    }
  }
  return Promise.reject(error);
};
// 请求拦截器
request.interceptors.request.use((config) => {
  config.headers = {
    "Content-Type": "application/json",
  };
  if (localStorage.getItem("Authorization")) {
    config.headers.satoken = localStorage.getItem("Authorization");
  }
  return config;
}, errorHandler);
// 响应拦截器
request.interceptors.response.use((response) => {
  return new Promise((resolve, reject) => {
    if (response.data.code + "" === "200") {
      return resolve(response.data);
    } else if (response.data.code === 401) {
      Message({
        showClose: true,
        message: "请重新登录",
        type: "error",
      });
      let param = {},
        path = routerIndex.history.current.path;
      console.log(path, "pathpathpath");
      if (path && path !== "/Login" && !path.startsWith("/admin")) {
        param.current = path;
      }
      if (path && path !== "/Login") {
        routerIndex.push({
          path: "/Login",
          query: param,
        });
      }
    } else {
      Message({
        showClose: true,
        message: response.data.message || "请求失败，请重试！",
        type: "error",
      });
      new Error(response);
      reject(response && response.data);
    }
  });
}, errorHandler);

export default request;
